export default __webpack_public_path__ + "static/media/arrow-drop-down.9e677f45.svg";